export const required = value => (value ? undefined : 'Обязательное поле');

export const maxLength = max => value =>
	value && value.length > max ? `Не более ${max} символов` : undefined;

export const minLength = min => value =>
	value && value.length < min ? `Не менее ${min} символов` : undefined;

export const emailOrPhone = value =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) && !/^((\+7|7|8)+([0-9]){10})$/gm.test(value)
		? 'Должно быть действительным электронным адресом или номером телефона'
		: undefined;

export const email = value =>
	value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
		? 'Неверный электронный адрес'
		: undefined;

export const phone = value =>
	value && !/^((\+7|7|8)+([0-9]){10})$/gm.test(value)
		? 'Неверный номер телефона'
		: undefined;



// WEBPACK FOOTER //
// ./src/validators/index.js